"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideSelectionType = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SideBySide_1 = require("ContentTokens/DataModels/SideBySide");
var WidgetManager_1 = require("../../WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var SideBySideToolbar_1 = require("./SideBySideToolbar");
var SideBySideSelector_1 = require("./SideBySideSelector");
var mobx_1 = require("mobx");
var DragGuidelines_1 = require("./DragGuidelines");
var SelectionOverlay_1 = require("./SelectionOverlay");
var lodash_1 = __importDefault(require("lodash"));
var SideBySideContext_1 = require("./SideBySideContext");
var SideBySideViewStore_1 = require("./SideBySideViewStore");
var SideBySide_2 = require("ContentTokens/Models/SideBySide");
var DragGrid_1 = require("./DragGrid");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var WithComplexWidgetHoverManager_1 = require("../WithComplexWidgetHoverManager");
var SideBySideSelectionType;
(function (SideBySideSelectionType) {
    SideBySideSelectionType["None"] = "None";
    SideBySideSelectionType["Outside"] = "Outside";
    SideBySideSelectionType["Around"] = "Around";
    SideBySideSelectionType["Inside"] = "Inside";
    SideBySideSelectionType["Full"] = "Full";
})(SideBySideSelectionType = exports.SideBySideSelectionType || (exports.SideBySideSelectionType = {}));
var NAME = "side-by-side";
var HOVER_DELAY = 80;
var SideBySideWidget = (function (_super) {
    __extends(SideBySideWidget, _super);
    function SideBySideWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.isHoveringOverSelector = false;
        _this.isHoveringOverDelete = false;
        _this.handleDelete = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.DeleteSideBySide,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.handleResize = function (event) {
            if (_this.props.selection !== SideBySideSelectionType.Full) {
                _this.handleSelectSideBySide();
            }
            _this.resizeManager.handleMouseDown(event);
        };
        _this.handleWidthChange = function (widthRange) {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.SetWidth,
                width: widthRange,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.handleSetPercentage = function (percentage) {
            if (_this.props.percent === percentage) {
                return;
            }
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.SetPercentage,
                percentage: percentage,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.handleContextualStyleClick = function () {
            alert("This functionality is not yet implemented");
        };
        _this.handleSelectSideBySide = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.SelectSideBySide,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.handleSelectorHoverChange = function (newHoverValue) {
            _this.isHoveringOverSelector = newHoverValue;
        };
        _this.handleDeleteHoverChange = function (newHoverValue) {
            _this.isHoveringOverDelete = newHoverValue;
        };
        _this.viewStore = new SideBySideViewStore_1.SideBySideViewStore();
        _this.dragManager = _this.viewStore.dragManager;
        var containerRef = (0, react_1.createRef)();
        _this.dragManager.setDragContainer(containerRef, _this.handleSetPercentage);
        _this.resizeManager = _this.viewStore.resizeManager;
        var resizeGrid = (0, react_1.createRef)();
        _this.resizeManager.setGridContainer(resizeGrid, _this.handleWidthChange, _this.handleSelectSideBySide);
        _this.resizeManager.setResizeContainer(containerRef);
        _this.debouncedSelectorHover = lodash_1.default.debounce(_this.handleSelectorHoverChange, HOVER_DELAY, {
            leading: false,
            trailing: true,
        });
        return _this;
    }
    SideBySideWidget.prototype.componentDidMount = function () {
        if (this.props.enableResizing) {
            this.resizeManager.prepareResizing(this.props.attributes.ref.current);
        }
    };
    SideBySideWidget.prototype.componentWillUnmount = function () {
        if (this.props.enableResizing) {
            this.resizeManager.cleanupResizing();
        }
    };
    SideBySideWidget.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, width = _b.width, alignment = _b.alignment, children = _b.children, attributes = _b.attributes, enableResizing = _b.enableResizing, selection = _b.selection;
        var sideBySideFullySelected = selection === SideBySideSelectionType.Full;
        var enableEditingControls = this.enableEditingControls;
        var renderSelectionOverlay = this.isHoveringOverSelector &&
            !sideBySideFullySelected &&
            !this.dragManager.isDragging &&
            !this.resizeManager.isResizing;
        var renderDeleteOverlay = this.isHoveringOverDelete && sideBySideFullySelected;
        var style = this.resizeManager.isResizing ? { width: this.resizeManager.draggingSize } : {};
        var allowResizing = enableEditingControls && enableResizing;
        var isHovered = this.props.hoverManager.isHovered && !this.dragManager.isDragging && this.enableEditingControls;
        var hoverManagerHandlers = this.props.hoverManager.handlers;
        var renderResizerHandles = this.resizeManager.isResizing || (sideBySideFullySelected && !this.dragManager.isDragging) || isHovered;
        return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)("side-by-side__wrapper", {
                "side-by-side__wrapper--is-resizing": this.resizeManager.isResizing,
            }), style: { width: this.resizeManager.contentAreaWidth }, onMouseEnter: hoverManagerHandlers.onMouseEnter, onMouseLeave: hoverManagerHandlers.onMouseLeave, onMouseDown: hoverManagerHandlers.onMouseMove }, attributes),
            enableEditingControls && (react_1.default.createElement(SideBySideSelector_1.SideBySideSelector, { onSelect: this.handleSelectSideBySide, isSelected: sideBySideFullySelected, onHoverChange: this.debouncedSelectorHover, width: width })),
            react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)(NAME, "".concat(NAME, "--").concat(width), "".concat(NAME, "--").concat(alignment), "".concat(NAME, "--widget"), (_a = {},
                    _a["".concat(NAME, "--is-selected")] = selection === SideBySideSelectionType.Around ||
                        (sideBySideFullySelected && !this.dragManager.isDragging) ||
                        this.resizeManager.isResizing,
                    _a["".concat(NAME, "--is-hovered")] = isHovered,
                    _a["".concat(NAME, "--is-dragging")] = this.dragManager.isDragging,
                    _a)), ref: this.dragManager.containerRef },
                react_1.default.createElement(SideBySideContext_1.SideBySideContext.Provider, { value: {
                        percent: this.props.percent,
                        placeholderIndex: this.props.placeholderIndex,
                        sideBySideFullySelected: sideBySideFullySelected,
                        viewStore: this.viewStore,
                        disableContentSelection: selection === SideBySideSelectionType.Around,
                        isHovered: this.props.hoverManager.isHovered,
                    } }, children),
                sideBySideFullySelected && !this.dragManager.isDragging && (react_1.default.createElement(SideBySideToolbar_1.SideBySideToolbar, { onContextualStyleClick: this.handleContextualStyleClick, onDeleteClick: this.handleDelete, onDeleteMouseEnter: function () { return _this.handleDeleteHoverChange(true); }, onDeleteMouseLeave: function () { return _this.handleDeleteHoverChange(false); } })),
                react_1.default.createElement(DragGuidelines_1.DragGuidelines, { isVisible: this.dragManager.isDragging && !this.resizeManager.isResizing, allowedPercentageValues: SideBySide_1.AllowedPercentageValues, currentDragPercentage: this.dragManager.snappedDragPercentage, onGuidelineEnter: this.dragManager.onGuidelineHover, onGuidelineLeave: this.dragManager.onGuidelineLeave }),
                react_1.default.createElement(SelectionOverlay_1.SelectionOverlay, { isVisible: renderSelectionOverlay }, "Select 2 column"),
                react_1.default.createElement(SelectionOverlay_1.SelectionOverlay, { isDestructive: true, isVisible: renderDeleteOverlay }),
                allowResizing && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, onEnter: utils_1.forceReflow, in: renderResizerHandles, timeout: kaleidoscope_1.AnimationDuration.Medium, classNames: "".concat(NAME, "__resizer-handle-") }, function (status) {
                        var _a;
                        return (react_1.default.createElement("div", { onMouseDown: _this.handleResize, className: (0, classnames_1.default)("".concat(NAME, "__resizer-handle--left"), "".concat(NAME, "__resizer-handle"), "".concat(NAME, "__resizer-handle--").concat(status), (_a = {},
                                _a["".concat(NAME, "__resizer-handle--selected")] = _this.resizeManager.isResizing,
                                _a)) }));
                    }),
                    react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, onEnter: utils_1.forceReflow, in: renderResizerHandles, timeout: kaleidoscope_1.AnimationDuration.Medium, classNames: "".concat(NAME, "__resizer-handle-") }, function (status) {
                        var _a;
                        return (react_1.default.createElement("div", { onMouseDown: _this.handleResize, className: (0, classnames_1.default)("".concat(NAME, "__resizer-handle--right"), "".concat(NAME, "__resizer-handle"), "".concat(NAME, "__resizer-handle--").concat(status), (_a = {},
                                _a["".concat(NAME, "__resizer-handle--selected")] = _this.resizeManager.isResizing,
                                _a)) }));
                    })))),
            allowResizing && (react_1.default.createElement(DragGrid_1.DragGrid, { isVisible: this.resizeManager.isResizing, dragGridRef: this.resizeManager.resizeGridRef, gridColumns: SideBySide_2.DragGridColumns, activeColumnRange: this.resizeManager.widthRange }))));
    };
    Object.defineProperty(SideBySideWidget.prototype, "enableEditingControls", {
        get: function () {
            return this.props.widgetManager.canEdit;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], SideBySideWidget.prototype, "isHoveringOverSelector", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], SideBySideWidget.prototype, "isHoveringOverDelete", void 0);
    SideBySideWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SideBySideWidget);
    return SideBySideWidget;
}(react_1.default.Component));
exports.default = (0, WithComplexWidgetHoverManager_1.withComplexWidgetHoverManager)(SideBySideWidget);
